import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './styles/index.css';
import App from "./App.tsx";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
      <Router basename={"/"}>
          <Routes>
            <Route path={"/:urlCode/*"} element={<App/>}/>
            <Route path="*" element={<div style={{ color: 'black' }}><h1>404 Not Found</h1><p>The page you requested does not exist.</p></div>} />
          </Routes>
      </Router>
  </StrictMode>,
)